import { render, staticRenderFns } from "./StoryCoverAddModal.vue?vue&type=template&id=b4894fb4&scoped=true"
import script from "./StoryCoverAddModal.vue?vue&type=script&lang=js"
export * from "./StoryCoverAddModal.vue?vue&type=script&lang=js"
import style0 from "./StoryCoverAddModal.vue?vue&type=style&index=0&id=b4894fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4894fb4",
  null
  
)

export default component.exports